import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { fontSizes, paddings } from 'packages/kakapo-ui-kit/components/buttons/ButtonShared';
import Breakpoint from 'packages/kakapo-ui-kit/helpers/Breakpoint';
import { ButtonSize, IButtonPropsExtended } from 'packages/kakapo-ui-kit/types/Button';

const style = css<IButtonPropsExtended>`
	font-size: 15px;
	color: #6c7680;
	font-weight: 700;
	padding: ${(props) => `${props.px ?? 13}px ${props.py ?? 13}px`};
	text-align: center;
	display: ${(props) => (props.fullWidth ? 'block' : 'inline-block')};
	width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
	border: none;
	background: transparent;

	cursor: pointer;
	&:hover {
		text-decoration: none;
	}

	@media screen and (max-width: ${Breakpoint.Small}) {
		font-size: 13px;
	}
`;

export default styled.button<IButtonPropsExtended>`
	${style}
	border-radius: 6px;
	transition: 150ms background-color ease-out;
	font-size: ${(props) => fontSizes[props.size ?? ButtonSize.Large]};
	padding: ${(props) => paddings[props.size ?? ButtonSize.Large]};
	&:hover {
		background-color: #ddd;
	}
	@media screen and (max-width: ${Breakpoint.Small}) {
		padding: ${(props) => (props.size === ButtonSize.Small ? '5px 12px' : '8px')};
		white-space: inherit;
	}

	svg {
		margin-right: ${(props) => (props.size === ButtonSize.Small ? '5px' : '10px')};
		vertical-align: middle;
	}

	line-height: 1.4;
`;

export const PlainButtonLink = styled(Link)<IButtonPropsExtended>`
	${style}
`;
